// Generated by run_regional_sea_level_daily.py. Do not edit by hand.
export const regionalSeaLevelMetadata = {
  "palau": {
    "scope": "palau",
    "label": "Palau EEZ",
    "dates": [
      "1993-01",
      "1993-02",
      "1993-03",
      "1993-04",
      "1993-05",
      "1993-06",
      "1993-07",
      "1993-08",
      "1993-09",
      "1993-10",
      "1993-11",
      "1993-12",
      "1994-01",
      "1994-02",
      "1994-03",
      "1994-04",
      "1994-05",
      "1994-06",
      "1994-07",
      "1994-08",
      "1994-09",
      "1994-10",
      "1994-11",
      "1994-12",
      "1995-01",
      "1995-02",
      "1995-03",
      "1995-04",
      "1995-05",
      "1995-06",
      "1995-07",
      "1995-08",
      "1995-09",
      "1995-10",
      "1995-11",
      "1995-12",
      "1996-01",
      "1996-02",
      "1996-03",
      "1996-04",
      "1996-05",
      "1996-06",
      "1996-07",
      "1996-08",
      "1996-09",
      "1996-10",
      "1996-11",
      "1996-12",
      "1997-01",
      "1997-02",
      "1997-03",
      "1997-04",
      "1997-05",
      "1997-06",
      "1997-07",
      "1997-08",
      "1997-09",
      "1997-10",
      "1997-11",
      "1997-12",
      "1998-01",
      "1998-02",
      "1998-03",
      "1998-04",
      "1998-05",
      "1998-06",
      "1998-07",
      "1998-08",
      "1998-09",
      "1998-10",
      "1998-11",
      "1998-12",
      "1999-01",
      "1999-02",
      "1999-03",
      "1999-04",
      "1999-05",
      "1999-06",
      "1999-07",
      "1999-08",
      "1999-09",
      "1999-10",
      "1999-11",
      "1999-12",
      "2000-01",
      "2000-02",
      "2000-03",
      "2000-04",
      "2000-05",
      "2000-06",
      "2000-07",
      "2000-08",
      "2000-09",
      "2000-10",
      "2000-11",
      "2000-12",
      "2001-01",
      "2001-02",
      "2001-03",
      "2001-04",
      "2001-05",
      "2001-06",
      "2001-07",
      "2001-08",
      "2001-09",
      "2001-10",
      "2001-11",
      "2001-12",
      "2002-01",
      "2002-02",
      "2002-03",
      "2002-04",
      "2002-05",
      "2002-06",
      "2002-07",
      "2002-08",
      "2002-09",
      "2002-10",
      "2002-11",
      "2002-12",
      "2003-01",
      "2003-02",
      "2003-03",
      "2003-04",
      "2003-05",
      "2003-06",
      "2003-07",
      "2003-08",
      "2003-09",
      "2003-10",
      "2003-11",
      "2003-12",
      "2004-01",
      "2004-02",
      "2004-03",
      "2004-04",
      "2004-05",
      "2004-06",
      "2004-07",
      "2004-08",
      "2004-09",
      "2004-10",
      "2004-11",
      "2004-12",
      "2005-01",
      "2005-02",
      "2005-03",
      "2005-04",
      "2005-05",
      "2005-06",
      "2005-07",
      "2005-08",
      "2005-09",
      "2005-10",
      "2005-11",
      "2005-12",
      "2006-01",
      "2006-02",
      "2006-03",
      "2006-04",
      "2006-05",
      "2006-06",
      "2006-07",
      "2006-08",
      "2006-09",
      "2006-10",
      "2006-11",
      "2006-12",
      "2007-01",
      "2007-02",
      "2007-03",
      "2007-04",
      "2007-05",
      "2007-06",
      "2007-07",
      "2007-08",
      "2007-09",
      "2007-10",
      "2007-11",
      "2007-12",
      "2008-01",
      "2008-02",
      "2008-03",
      "2008-04",
      "2008-05",
      "2008-06",
      "2008-07",
      "2008-08",
      "2008-09",
      "2008-10",
      "2008-11",
      "2008-12",
      "2009-01",
      "2009-02",
      "2009-03",
      "2009-04",
      "2009-05",
      "2009-06",
      "2009-07",
      "2009-08",
      "2009-09",
      "2009-10",
      "2009-11",
      "2009-12",
      "2010-01",
      "2010-02",
      "2010-03",
      "2010-04",
      "2010-05",
      "2010-06",
      "2010-07",
      "2010-08",
      "2010-09",
      "2010-10",
      "2010-11",
      "2010-12",
      "2011-01",
      "2011-02",
      "2011-03",
      "2011-04",
      "2011-05",
      "2011-06",
      "2011-07",
      "2011-08",
      "2011-09",
      "2011-10",
      "2011-11",
      "2011-12",
      "2012-01",
      "2012-02",
      "2012-03",
      "2012-04",
      "2012-05",
      "2012-06",
      "2012-07",
      "2012-08",
      "2012-09",
      "2012-10",
      "2012-11",
      "2012-12",
      "2013-01",
      "2013-02",
      "2013-03",
      "2013-04",
      "2013-05",
      "2013-06",
      "2013-07",
      "2013-08",
      "2013-09",
      "2013-10",
      "2013-11",
      "2013-12",
      "2014-01",
      "2014-02",
      "2014-03",
      "2014-04",
      "2014-05",
      "2014-06",
      "2014-07",
      "2014-08",
      "2014-09",
      "2014-10",
      "2014-11",
      "2014-12",
      "2015-01",
      "2015-02",
      "2015-03",
      "2015-04",
      "2015-05",
      "2015-06",
      "2015-07",
      "2015-08",
      "2015-09",
      "2015-10",
      "2015-11",
      "2015-12",
      "2016-01",
      "2016-02",
      "2016-03",
      "2016-04",
      "2016-05",
      "2016-06",
      "2016-07",
      "2016-08",
      "2016-09",
      "2016-10",
      "2016-11",
      "2016-12",
      "2017-01",
      "2017-02",
      "2017-03",
      "2017-04",
      "2017-05",
      "2017-06",
      "2017-07",
      "2017-08",
      "2017-09",
      "2017-10",
      "2017-11",
      "2017-12",
      "2018-01",
      "2018-02",
      "2018-03",
      "2018-04",
      "2018-05",
      "2018-06",
      "2018-07",
      "2018-08",
      "2018-09",
      "2018-10",
      "2018-11",
      "2018-12",
      "2019-01",
      "2019-02",
      "2019-03",
      "2019-04",
      "2019-05",
      "2019-06",
      "2019-07",
      "2019-08",
      "2019-09",
      "2019-10",
      "2019-11",
      "2019-12",
      "2020-01",
      "2020-02",
      "2020-03",
      "2020-04",
      "2020-05",
      "2020-06",
      "2020-07",
      "2020-08",
      "2020-09",
      "2020-10",
      "2020-11",
      "2020-12",
      "2021-01",
      "2021-02",
      "2021-03",
      "2021-04",
      "2021-05",
      "2021-06",
      "2021-07",
      "2021-08",
      "2021-09",
      "2021-10",
      "2021-11",
      "2021-12",
      "2022-01",
      "2022-02",
      "2022-03",
      "2022-04",
      "2022-05",
      "2022-06",
      "2022-07",
      "2022-08",
      "2022-09",
      "2022-10",
      "2022-11",
      "2022-12",
      "2023-01",
      "2023-02",
      "2023-03",
      "2023-04"
    ],
    "historyStart": "1993-01-01",
    "historyEnd": "2023-04-30",
    "palette": {
      "name": "mako",
      "min": -0.56,
      "max": 0.44,
      "unit": "m"
    },
    "stations": [
      {
        "id": "7",
        "name": "Malakal",
        "latitude": 7.329999923706055,
        "longitude": 134.46299743652344,
        "path": "timeseries/stations/7.csv",
        "source": "UHSLC daily Fast Delivery",
        "nearestCellId": "7.375_134.375",
        "nearestHistoryBlock": "+00_130",
        "nearestLatitude": 7.375,
        "nearestLongitude": 134.375
      }
    ],
    "view": {
      "latitude": 7.34,
      "longitude": 134.48,
      "zoom": 5.0
    },
    "updated": "2026-08-21T22:45:57.410895Z"
  },
  "rmi": {
    "scope": "rmi",
    "label": "Marshall Islands EEZ",
    "dates": [
      "1993-01",
      "1993-02",
      "1993-03",
      "1993-04",
      "1993-05",
      "1993-06",
      "1993-07",
      "1993-08",
      "1993-09",
      "1993-10",
      "1993-11",
      "1993-12",
      "1994-01",
      "1994-02",
      "1994-03",
      "1994-04",
      "1994-05",
      "1994-06",
      "1994-07",
      "1994-08",
      "1994-09",
      "1994-10",
      "1994-11",
      "1994-12",
      "1995-01",
      "1995-02",
      "1995-03",
      "1995-04",
      "1995-05",
      "1995-06",
      "1995-07",
      "1995-08",
      "1995-09",
      "1995-10",
      "1995-11",
      "1995-12",
      "1996-01",
      "1996-02",
      "1996-03",
      "1996-04",
      "1996-05",
      "1996-06",
      "1996-07",
      "1996-08",
      "1996-09",
      "1996-10",
      "1996-11",
      "1996-12",
      "1997-01",
      "1997-02",
      "1997-03",
      "1997-04",
      "1997-05",
      "1997-06",
      "1997-07",
      "1997-08",
      "1997-09",
      "1997-10",
      "1997-11",
      "1997-12",
      "1998-01",
      "1998-02",
      "1998-03",
      "1998-04",
      "1998-05",
      "1998-06",
      "1998-07",
      "1998-08",
      "1998-09",
      "1998-10",
      "1998-11",
      "1998-12",
      "1999-01",
      "1999-02",
      "1999-03",
      "1999-04",
      "1999-05",
      "1999-06",
      "1999-07",
      "1999-08",
      "1999-09",
      "1999-10",
      "1999-11",
      "1999-12",
      "2000-01",
      "2000-02",
      "2000-03",
      "2000-04",
      "2000-05",
      "2000-06",
      "2000-07",
      "2000-08",
      "2000-09",
      "2000-10",
      "2000-11",
      "2000-12",
      "2001-01",
      "2001-02",
      "2001-03",
      "2001-04",
      "2001-05",
      "2001-06",
      "2001-07",
      "2001-08",
      "2001-09",
      "2001-10",
      "2001-11",
      "2001-12",
      "2002-01",
      "2002-02",
      "2002-03",
      "2002-04",
      "2002-05",
      "2002-06",
      "2002-07",
      "2002-08",
      "2002-09",
      "2002-10",
      "2002-11",
      "2002-12",
      "2003-01",
      "2003-02",
      "2003-03",
      "2003-04",
      "2003-05",
      "2003-06",
      "2003-07",
      "2003-08",
      "2003-09",
      "2003-10",
      "2003-11",
      "2003-12",
      "2004-01",
      "2004-02",
      "2004-03",
      "2004-04",
      "2004-05",
      "2004-06",
      "2004-07",
      "2004-08",
      "2004-09",
      "2004-10",
      "2004-11",
      "2004-12",
      "2005-01",
      "2005-02",
      "2005-03",
      "2005-04",
      "2005-05",
      "2005-06",
      "2005-07",
      "2005-08",
      "2005-09",
      "2005-10",
      "2005-11",
      "2005-12",
      "2006-01",
      "2006-02",
      "2006-03",
      "2006-04",
      "2006-05",
      "2006-06",
      "2006-07",
      "2006-08",
      "2006-09",
      "2006-10",
      "2006-11",
      "2006-12",
      "2007-01",
      "2007-02",
      "2007-03",
      "2007-04",
      "2007-05",
      "2007-06",
      "2007-07",
      "2007-08",
      "2007-09",
      "2007-10",
      "2007-11",
      "2007-12",
      "2008-01",
      "2008-02",
      "2008-03",
      "2008-04",
      "2008-05",
      "2008-06",
      "2008-07",
      "2008-08",
      "2008-09",
      "2008-10",
      "2008-11",
      "2008-12",
      "2009-01",
      "2009-02",
      "2009-03",
      "2009-04",
      "2009-05",
      "2009-06",
      "2009-07",
      "2009-08",
      "2009-09",
      "2009-10",
      "2009-11",
      "2009-12",
      "2010-01",
      "2010-02",
      "2010-03",
      "2010-04",
      "2010-05",
      "2010-06",
      "2010-07",
      "2010-08",
      "2010-09",
      "2010-10",
      "2010-11",
      "2010-12",
      "2011-01",
      "2011-02",
      "2011-03",
      "2011-04",
      "2011-05",
      "2011-06",
      "2011-07",
      "2011-08",
      "2011-09",
      "2011-10",
      "2011-11",
      "2011-12",
      "2012-01",
      "2012-02",
      "2012-03",
      "2012-04",
      "2012-05",
      "2012-06",
      "2012-07",
      "2012-08",
      "2012-09",
      "2012-10",
      "2012-11",
      "2012-12",
      "2013-01",
      "2013-02",
      "2013-03",
      "2013-04",
      "2013-05",
      "2013-06",
      "2013-07",
      "2013-08",
      "2013-09",
      "2013-10",
      "2013-11",
      "2013-12",
      "2014-01",
      "2014-02",
      "2014-03",
      "2014-04",
      "2014-05",
      "2014-06",
      "2014-07",
      "2014-08",
      "2014-09",
      "2014-10",
      "2014-11",
      "2014-12",
      "2015-01",
      "2015-02",
      "2015-03",
      "2015-04",
      "2015-05",
      "2015-06",
      "2015-07",
      "2015-08",
      "2015-09",
      "2015-10",
      "2015-11",
      "2015-12",
      "2016-01",
      "2016-02",
      "2016-03",
      "2016-04",
      "2016-05",
      "2016-06",
      "2016-07",
      "2016-08",
      "2016-09",
      "2016-10",
      "2016-11",
      "2016-12",
      "2017-01",
      "2017-02",
      "2017-03",
      "2017-04",
      "2017-05",
      "2017-06",
      "2017-07",
      "2017-08",
      "2017-09",
      "2017-10",
      "2017-11",
      "2017-12",
      "2018-01",
      "2018-02",
      "2018-03",
      "2018-04",
      "2018-05",
      "2018-06",
      "2018-07",
      "2018-08",
      "2018-09",
      "2018-10",
      "2018-11",
      "2018-12",
      "2019-01",
      "2019-02",
      "2019-03",
      "2019-04",
      "2019-05",
      "2019-06",
      "2019-07",
      "2019-08",
      "2019-09",
      "2019-10",
      "2019-11",
      "2019-12",
      "2020-01",
      "2020-02",
      "2020-03",
      "2020-04",
      "2020-05",
      "2020-06",
      "2020-07",
      "2020-08",
      "2020-09",
      "2020-10",
      "2020-11",
      "2020-12",
      "2021-01",
      "2021-02",
      "2021-03",
      "2021-04",
      "2021-05",
      "2021-06",
      "2021-07",
      "2021-08",
      "2021-09",
      "2021-10",
      "2021-11",
      "2021-12",
      "2022-01",
      "2022-02",
      "2022-03",
      "2022-04",
      "2022-05",
      "2022-06",
      "2022-07",
      "2022-08",
      "2022-09",
      "2022-10",
      "2022-11",
      "2022-12",
      "2023-01",
      "2023-02",
      "2023-03",
      "2023-04",
      "2023-05",
      "2023-06",
      "2023-07",
      "2023-08",
      "2023-09",
      "2023-10",
      "2023-11",
      "2023-12",
      "2024-01",
      "2024-02",
      "2024-03",
      "2024-04",
      "2024-05",
      "2024-06",
      "2024-07",
      "2024-08",
      "2024-09",
      "2024-10",
      "2024-11",
      "2024-12",
      "2025-01",
      "2025-02",
      "2025-03",
      "2025-04",
      "2025-05",
      "2025-06",
      "2025-07",
      "2025-08",
      "2025-09",
      "2025-10",
      "2025-11",
      "2025-12"
    ],
    "historyStart": "1993-01-01",
    "historyEnd": "2025-12-31",
    "palette": {
      "name": "mako",
      "min": -0.56,
      "max": 0.44,
      "unit": "m"
    },
    "stations": [
      {
        "id": "5",
        "name": "Majuro",
        "latitude": 7.10699987411499,
        "longitude": 171.3730010986328,
        "path": "timeseries/stations/5.csv",
        "source": "UHSLC daily Fast Delivery",
        "nearestCellId": "7.125_171.375",
        "nearestHistoryBlock": "+00_170",
        "nearestLatitude": 7.125,
        "nearestLongitude": 171.375
      },
      {
        "id": "55",
        "name": "Kwajalein",
        "latitude": 8.732999801635742,
        "longitude": 167.73300170898438,
        "path": "timeseries/stations/55.csv",
        "source": "UHSLC daily Fast Delivery",
        "nearestCellId": "8.625_167.625",
        "nearestHistoryBlock": "+00_160",
        "nearestLatitude": 8.625,
        "nearestLongitude": 167.625
      }
    ],
    "view": {
      "latitude": 9.9,
      "longitude": 166.5,
      "zoom": 4.3
    },
    "updated": "2026-08-24T21:05:49.971686Z"
  }
};
export const regionalSeaLevelDates = Object.fromEntries(Object.entries(regionalSeaLevelMetadata).map(([key, value]) => [key, value.dates || []]));
